export default "__VITE_ASSET__be81dbd5__"